import { render, staticRenderFns } from "./product-fun.vue?vue&type=template&id=29bc1432&scoped=true"
import script from "./product-fun.vue?vue&type=script&lang=js"
export * from "./product-fun.vue?vue&type=script&lang=js"
import style0 from "./product-fun.vue?vue&type=style&index=0&id=29bc1432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc1432",
  null
  
)

export default component.exports